import React from "react";
import { motion } from "framer-motion";
import { usePageSettings } from "../../../../contexts/PageSettingsContext";

export const PriceSummary = ({ planPrice, addonPrice, totalPrice, paymentCycle, selectedPlan }) => {
	// Animation variants for numbers
	const { translations } = usePageSettings();
	const { currency } = usePageSettings();
	const numberVariants = {
		hidden: { opacity: 0, y: 10 }, // Start below with no opacity
		visible: { opacity: 1, y: 0 }, // Move into position and become visible
	};

	return (
		<div className="flex flex-col">
			{/* Plan Price */}
			<div className="flex justify-between w-full pb-1 text-sm text-ipxon-white">
				<span className="font-bold text-sm">{translations["PriceSummarySubtotal"]}</span>
				<span
					key={planPrice} // Trigger animation when value changes
					variants={numberVariants}
					initial="hidden"
					animate="visible"
					transition={{ duration: 0.3, ease: "easeOut" }}
					className="uppercase font-bold"
				>
					{["storage", "ultraproxy", "iptransit", "bgp"].includes(selectedPlan?.service?.toLowerCase()) &&
						(!selectedPlan?.id || selectedPlan.id === "")
						? totalPrice
						: planPrice}
				</span>
			</div>
			{/* Addon Price */}
			{addonPrice && (
				<div className={`flex justify-between w-full pb-1 text-sm text-ipxon-white h-6`}>
					<span>{translations["PriceSummarySettings"]}</span>
					<span
						key={addonPrice} // Trigger animation when value changes
						variants={numberVariants}
						initial="hidden"
						animate="visible"
						transition={{ duration: 0.3, ease: "easeOut", delay: 0.1 }}
						className="uppercase"
					>
						{addonPrice}
					</span>
				</div>
			)}

			<div className="flex justify-between w-full text-sm text-ipxon-white pb-7">
				<span>{translations["PriceSummaryInstallation"]}</span>
				<span
					key={planPrice} // Trigger animation when value changes
					variants={numberVariants}
					initial="hidden"
					animate="visible"
					transition={{ duration: 0.3, ease: "easeOut" }}
					className="uppercase"
				>
					$00.00 {currency}
				</span>
			</div>

			{/* <div className="flex justify-between w-full py-7 border-b border-ipxon-gradient-black-lighter text-sm text-ipxon-white">
				<span>Facturacion {paymentCycle}</span>
				<span
					key={paymentCycle} // Trigger animation when value changes
					variants={numberVariants}
					initial="hidden"
					animate="visible"
					transition={{ duration: 0.3, ease: "easeOut", delay: 0.1 }}
					className="uppercase"
				>
					{planPrice}
				</span>
			</div> */}

			{/* Total Price */}
			<div className="flex w-full justify-between font-bold text-ipxon-light-medium-gray text-base pt-7 border-t border-ipxon-gradient-black-lighter">
				<span className="capitalize">{translations["PriceSummaryTotal"]}</span>
				<span
					key={totalPrice} // Trigger animation when value changes
					variants={numberVariants}
					initial="hidden"
					animate="visible"
					transition={{ duration: 0.3, ease: "easeOut", delay: 0.2 }}
					className="uppercase"
				>
					{totalPrice}
				</span>
			</div>
		</div>
	);
};
